import React, { useState, useEffect, useCallback } from "react";
import axios from "../utils/axiosInstance";
import { useToast } from "./ConfirmDialog";

const API = "";

const Styles = () => (
  <style>{`
.ir-form-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  overflow: hidden;
  margin-bottom: 24px;
}
.ir-form-header {
  background: #003366;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 3px solid #FFD700;
}
.ir-form-header i { color: #FFD700; font-size: 1.3rem; }
.ir-form-header h3 { color: #ffffff; font-size: 1rem; font-weight: 700; margin: 0; }
.ir-form-body { padding: 20px; }
.ir-form-group { margin-bottom: 16px; }
.ir-form-group label {
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 6px;
}
.ir-form-group label .required { color: #dc2626; margin-left: 2px; }
.ir-form-group input,
.ir-form-group textarea,
.ir-form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  font-size: 0.85rem;
  color: #1e293b;
  background: #f8fafc;
  transition: all 0.2s ease;
  font-family: inherit;
}
.ir-form-group input:focus,
.ir-form-group textarea:focus,
.ir-form-group select:focus {
  outline: none;
  border-color: #003366;
  box-shadow: 0 0 0 3px rgba(0,51,102,0.1);
  background: #ffffff;
}
.ir-form-group textarea { min-height: 100px; resize: vertical; }
.ir-form-group .hint { font-size: 0.7rem; color: #64748b; margin-top: 4px; }
.ir-btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #003366;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.ir-btn-primary:hover { background: #004080; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,51,102,0.3); }
.ir-btn-primary:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
.ir-btn-success {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: #1a7a4a;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.ir-btn-success:hover { background: #20603D; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(26,122,74,0.3); }
.ir-btn-success:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
.ir-success-box {
  background: rgba(26,122,74,0.08);
  border: 1px solid rgba(26,122,74,0.2);
  border-radius: 8px;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
}
.ir-success-box i { color: #1a7a4a; font-size: 1.5rem; }
.ir-success-box p { color: #1a7a4a; font-size: 0.85rem; font-weight: 500; margin: 0; flex: 1; }
.ir-table-wrap {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.ir-table-scroll { overflow-x: auto; }
.ir-table { width: 100%; border-collapse: collapse; font-size: 0.8rem; }
.ir-table th {
  text-align: left; padding: 10px 16px;
  font-size: 0.65rem; font-weight: 700; color: #64748b;
  text-transform: uppercase; letter-spacing: 0.07em;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc; white-space: nowrap;
}
.ir-table td { padding: 10px 16px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; color: #1e293b; }
.ir-table tbody tr:hover { background: #f0f4f8; }
.ir-table tbody tr:last-child td { border-bottom: none; }
.ir-empty { text-align: center; padding: 40px 20px; color: #64748b; font-size: 0.85rem; }
.ir-status { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; }
.ir-status-pending { background: #fef3c7; color: #b45309; }
.ir-status-sent { background: #d1fae5; color: #065f46; }
.ir-btn-send {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: #1a7a4a;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.ir-btn-send:hover { background: #15803d; transform: translateY(-1px); }
.ir-btn-send:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
  `}</style>
);

const IR_EXAMPLES = [
  "Umuhanda", "Amazi", "Umuyoboro w'amashanyarazi",
  "Ikiraro", "Icyumba cy'ishuri", "Ikindi"
];

export default function IbikorwaRemezoForm() {
  const { toast } = useToast();
  const [form, setForm] = useState({
    izina_ry_umuturage: "",
    nimero_yirangamuntu: "",
    upa_y_icyibanza: "",
    izina_isibo: "",
    icyibanza: "",
    igikorwa_remezo: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [savedRecord, setSavedRecord] = useState(null);
  const [sending, setSending] = useState(false);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchRecords = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/ibikorwa-remezo`);
      setRecords(res.data || []);
    } catch {
      // silent
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchRecords(); }, [fetchRecords]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "nimero_yirangamuntu") {
      const cleaned = value.replace(/\D/g, "").slice(0, 16);
      setForm((prev) => ({ ...prev, [name]: cleaned }));
      return;
    }
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.izina_ry_umuturage || !form.nimero_yirangamuntu || !form.upa_y_icyibanza || !form.izina_isibo || !form.icyibanza || !form.igikorwa_remezo) {
      toast({ type: "warning", title: "Ikosa", message: "Uzuza ibisabwa byose" });
      return;
    }
    if (!/^\d{16}$/.test(form.nimero_yirangamuntu)) {
      toast({ type: "warning", title: "Ikosa", message: "Nimero y'Irangamuntu igomba kuba imibare 16" });
      return;
    }
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/api/ibikorwa-remezo`, form);
      toast({ type: "success", title: "Byakunze!", message: res.data.message });
      setSavedRecord({ id: res.data.id, ...form });
      setForm({ izina_ry_umuturage: "", nimero_yirangamuntu: "", upa_y_icyibanza: "", izina_isibo: "", icyibanza: "", igikorwa_remezo: "" });
      fetchRecords();
    } catch (err) {
      const msg = err.response?.data?.error || "Habaye ikosa";
      toast({ type: "danger", title: "Ikosa", message: msg });
    } finally {
      setSubmitting(false);
    }
  };

  const handleSend = async (id) => {
    setSending(true);
    try {
      const res = await axios.patch(`${API}/api/ibikorwa-remezo/${id}/send`);
      toast({ type: "success", title: "Byoherejwe!", message: res.data.message });
      setSavedRecord(null);
      fetchRecords();
    } catch (err) {
      const msg = err.response?.data?.error || "Habaye ikosa";
      toast({ type: "danger", title: "Ikosa", message: msg });
    } finally {
      setSending(false);
    }
  };

  const formatDate = (d) => {
    if (!d) return "";
    return new Date(d).toLocaleDateString("rw-RW", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  return (
    <>
      <Styles />
      <div style={{ maxWidth: 800, margin: "0 auto" }}>
        {/* Form Card */}
        <div className="ir-form-card">
          <div className="ir-form-header">
            <i className="bi bi-building-gear" />
            <h3>Ibikorwa Remezo - Kwandika</h3>
          </div>
          <div className="ir-form-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="ir-form-group">
                    <label>Izina ry'Umuturage <span className="required">*</span></label>
                    <input type="text" name="izina_ry_umuturage" value={form.izina_ry_umuturage} onChange={handleChange} placeholder="Andika izina ry'umuturage" required />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="ir-form-group">
                    <label>Nimero y'Irangamuntu <span className="required">*</span></label>
                    <input type="text" name="nimero_yirangamuntu" value={form.nimero_yirangamuntu} onChange={handleChange} placeholder="Indangamuntu 16" maxLength={16} required />
                    <div className="hint">{form.nimero_yirangamuntu.length}/16</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="ir-form-group">
                    <label>UPA y'Icyibanza <span className="required">*</span></label>
                    <input type="text" name="upa_y_icyibanza" value={form.upa_y_icyibanza} onChange={handleChange} placeholder="Andika UPA" required />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="ir-form-group">
                    <label>Izina ry'Isibo <span className="required">*</span></label>
                    <input type="text" name="izina_isibo" value={form.izina_isibo} onChange={handleChange} placeholder="Icyizere, Ubumwe, Twubake..." required />
                    <div className="hint">Andika izina ry'isibo ry'umuturage</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="ir-form-group">
                    <label>Icyibanza cy'Umuturage <span className="required">*</span></label>
                    <input type="text" name="icyibanza" value={form.icyibanza} onChange={handleChange} placeholder="Andika icyibanza" required />
                  </div>
                </div>
                <div className="col-12">
                  <div className="ir-form-group">
                    <label>Igikorwa Remezo kigiye gukorwa <span className="required">*</span></label>
                    <textarea
                      name="igikorwa_remezo"
                      value={form.igikorwa_remezo}
                      onChange={handleChange}
                      placeholder="Ingero: Umuhanda, Amazi, Umuyoboro w'amashanyarazi, Ikiraro, Icyumba cy'ishuri, Ikindi..."
                      required
                    />
                    <div className="hint">Ingero: {IR_EXAMPLES.join(", ")}</div>
                  </div>
                </div>
              </div>

              <div style={{ marginTop: 20, display: "flex", gap: 12, flexWrap: "wrap" }}>
                <button type="submit" className="ir-btn-primary" disabled={submitting}>
                  {submitting ? <><span className="spinner-border spinner-border-sm" /> Bitegereza...</> : <><i className="bi bi-save" /> Kubika Amakuru</>}
                </button>
              </div>
            </form>

            {savedRecord && (
              <div className="ir-success-box">
                <i className="bi bi-check-circle-fill" />
                <p>Amakuru yabitswe neza! Ushobora kohereza ku Mudugudu.</p>
                <button className="ir-btn-success" disabled={sending} onClick={() => handleSend(savedRecord.id)}>
                  {sending ? <span className="spinner-border spinner-border-sm" /> : <><i className="bi bi-send" /> Ohereza ku Mudugudu</>}
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Records Table */}
        <div className="ir-table-wrap">
          <div className="ir-form-header" style={{ background: "#1e293b" }}>
            <i className="bi bi-list-ul" />
            <h3>Ibikorwa Remezo Byanditswe</h3>
          </div>
          <div className="ir-table-scroll">
            <table className="ir-table">
              <thead>
                <tr>
                  <th>Izina</th>
                  <th>Indangamuntu</th>
                  <th>UPA</th>
                  <th>Isibo</th>
                  <th>Igikorwa</th>
                  <th>Itariki</th>
                  <th>Status</th>
                  <th>Ibikorwa</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={8} className="ir-empty">Bitegereza...</td></tr>
                ) : records.length === 0 ? (
                  <tr><td colSpan={8} className="ir-empty">Nta bikorwa remezo byanditswe</td></tr>
                ) : (
                  records.map((r) => (
                    <tr key={r.id}>
                      <td style={{ fontWeight: 600, color: "#1e293b" }}>{r.izina_ry_umuturage}</td>
                      <td>{r.nimero_yirangamuntu}</td>
                      <td>{r.upa_y_icyibanza}</td>
                      <td>{r.izina_isibo}</td>
                      <td>{r.igikorwa_remezo}</td>
                      <td style={{ fontSize: "0.75rem", color: "#64748b" }}>{formatDate(r.created_at)}</td>
                      <td>
                        <span className={`ir-status ${r.status === "sent_to_umudugudu" ? "ir-status-sent" : "ir-status-pending"}`}>
                          <i className={`bi ${r.status === "sent_to_umudugudu" ? "bi-check-circle" : "bi-clock"}`} />
                          {r.status === "sent_to_umudugudu" ? "Byoherejwe" : "Itegereje"}
                        </span>
                      </td>
                      <td>
                        {r.status === "pending" && (
                          <button className="ir-btn-send" onClick={() => handleSend(r.id)} disabled={sending}>
                            <i className="bi bi-send" /> Ohereza
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
